var Avis_List = {
    init:function(){
/*
        console.log("Avis_list init");
        var _html = $('.liste-avis .jdgm-rev-widg__reviews').html();

        for (var i = 0; i < 7; i++){
            $('.liste-avis .jdgm-rev-widg__reviews').append(_html);
        }
*/
        $('.liste-avis .jdgm-rev-widg__reviews').masonry({
            // options
            itemSelector: '.jdgm-rev',
            gutter: 20,
            percentPosition: true
        });
    }
}
var Btn_All_Reviews = {
    init:function(){
        $(".all-reviews-header .btn").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }

            var _hdest =  $(".jdgm-all-reviews-page__wrapper").offset().top - 100;

            $("html, body").animate({scrollTop:_hdest}, 10);
        })
    }
}
$(window).on("load", function(){
    if($(".liste-avis").length){
        Avis_List.init();
    }

    if($(".all-reviews-header").length){
        Btn_All_Reviews.init();
    }
})